<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.modelId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <v-container>
              <MachineTypeSelect v-if="!hideMachineTypeFilter" v-model="typesfilter" multiple clearable externaledit>
              </MachineTypeSelect>
              <SupplierSelect v-if="!hideSupplierFilter" v-model="suppliersfilter" multiple clearable externaledit
                class="my-3">
              </SupplierSelect>
            </v-container>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getMachineModelListFromFilter" :lockedFilters="lockedFilters"
          :optional-filters="filters" :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="false"
          :itemsPerPage="100" :open-function="openItem" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)" />
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import MachineTypeSelect from "@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import ListItem from "@/components/ListItems/MachineModelListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminMachineModels",
  props: {
    hideMachineTypeFilter: Boolean,
    hideSupplierFilter: Boolean,
    lockedFilters: Object,
  },
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
    DefaultLifeCycleFilterGroup,
    SupplierSelect,
    MachineTypeSelect,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "MML-",
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "MachineModels") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewMachineModel', params: { modelId: item.Id }, query })
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          SupplierIdList: this.suppliersfilter,
          MachineTypeIdList: this.typesfilter,
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    typesfilter: {
      get() { return this.getQueryParam("filter-types", []); },
      set(update) { this.setQueryParam("filter-types", update); },
    },

    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },
  },

  watch: {},
};
</script>